<template>
  <div class="ml-10">
    <label>{{ text }}</label>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "JobDayHeader",
  props: {
    day_index: {
      type: Number,
      required: true,
    },
    day_only: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    week_index: 0,
    text: "",
    days: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thusday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
  }),
  mounted() {
    this.$nextTick(() => {
      this.week_index = this.selected_week;
      if (this.day_only) {
        this.text = this.days[this.day_index];
      } else {
        this.text = moment(this.schedule_start_date)
          .add(this.week_index * 7 + this.day_index, "days")
          .format("dddd DD/MM");
      }
    });
  },
  computed: {
    ...mapState("schedule", ["schedule_start_date", "selected_week"]),
  },
  watch: {
    schedule_start_date(new_value) {
      if (this.day_only) {
        this.text = this.days[this.day_index];
      } else {
        this.text = moment(new_value)
          .add(this.week_index * 7 + this.day_index, "days")
          .format("dddd DD/MM");
      }
    },
    selected_week(new_value) {
      this.week_index = new_value;
      if (this.day_only) {
        this.text = this.days[this.day_index];
      } else {
        this.text = moment(this.schedule_start_date)
          .add(this.week_index * 7 + this.day_index, "days")
          .format("dddd DD/MM");
      }
    },
  },
  methods: {
    moment(arg) {
      return moment(arg);
    },
  },
};
</script>
